import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Splitting from "splitting";

const hero = document.querySelector(".qsd-hero");
const heroMedia = document.querySelector(".qsd-hero__media > img");

gsap.registerPlugin(ScrollTrigger);

// First animation: scale to 1.05
gsap.to(heroMedia, {
  scale: 1.05,
  duration: 1,
  ease: "easeInOut",
  onComplete: function () {
    // Initialize scroll-triggered animation after the first one completes
    gsap.fromTo(
      heroMedia,
      {
        scale: 1.05, // Start scaling from 1.05
      },
      {
        scale: 1.5, // Animate scale up to 1.5
        scrollTrigger: {
          trigger: hero,
          start: "top top",
          end: "bottom top",
          scrub: 1.5,
        },
      }
    );
  },
});

// Check if the viewport width is less than 480px for the object-position animation
// if (window.innerWidth < 480) {
// Animate object-position from left to right and back (yoyo effect)
gsap.to(heroMedia, {
  duration: 25, // Duration of one way of the animation
  ease: "none", // Linear ease for smooth movement
  objectPosition: "100% center", // Move from left (default is 0% center) to right
  repeat: -1, // Repeat the animation indefinitely
  yoyo: true, // Go back and forth between the starting and ending values
});
// }

// Title animation

Splitting({
  target: ".data-splitting",
});

const fx6Title = document.querySelector(".qsd-hero__headline");

const words = fx6Title.querySelectorAll(".word");

for (const word of words) {
  const chars = word.querySelectorAll(".char");

  chars.forEach((char) => gsap.set(char.parentNode, { perspective: 2000 }));

  gsap.fromTo(
    chars,
    {
      "will-change": "opacity, transform",
      opacity: 0,
      rotationX: -90,
      yPercent: 50,
    },
    {
      ease: "power1.inOut",
      opacity: 1,
      rotationX: 0,
      yPercent: 0,
      stagger: {
        each: 0.06,
        from: 0,
      },
      duration: 1.5,
    }
  );
}

const subtitle = document.querySelector(".qsd-hero__subtitle");

gsap.from(subtitle, {
  opacity: 0,
  delay: 1.75,
  duration: 0.75,
});
